import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import helpers from "./helpers.js";

import "./AutoClicker.css";

export default class AutoClicker extends PureComponent {
  static propTypes = {
    forceInvisible: PropTypes.bool,
    automateCost: PropTypes.number.isRequired,
    unlockCost: PropTypes.number.isRequired,
    currentNumber: PropTypes.number.isRequired,
    costBaseline: PropTypes.number.isRequired,
    costMultiplier: PropTypes.number.isRequired,
    incomeBaseline: PropTypes.number.isRequired,
    incomeMultiplier: PropTypes.number.isRequired,
    incrementNumber: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    waitTime: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);

    const {
      unlockCost,
      costBaseline,
      costMultiplier,
      incomeBaseline,
      incomeMultiplier
    } = props;

    this.state = {
      currentLevel: 0,
      isAutomated: false,
      isUnlocked: unlockCost === 0,
      isWaiting: false,
      costBaseline,
      costMultiplier,
      incomeBaseline,
      incomeMultiplier
    };
  }

  getCurrentIncome = () => {
    const { incomeBaseline, incomeMultiplier } = this.props;
    const { currentLevel } = this.state;

    return incomeBaseline * Math.pow(incomeMultiplier, currentLevel);
  };

  getCurrentCost = () => {
    const { costBaseline, costMultiplier } = this.props;
    const { currentLevel } = this.state;

    return costBaseline * Math.pow(costMultiplier, currentLevel);
  };

  canUpgrade = () => {
    const { currentNumber } = this.props;
    return currentNumber > this.getCurrentCost();
  };

  doUpgrade = () => {
    const { incrementNumber } = this.props;
    const currentCost = this.getCurrentCost();

    incrementNumber(-currentCost);
    this.setState(state => ({ currentLevel: state.currentLevel + 1 }));
  };

  canUnlock = () => {
    const { unlockCost, currentNumber } = this.props;
    const { isUnlocked } = this.state;
    return !isUnlocked && currentNumber > unlockCost;
  };

  doUnlock = () => {
    const { incrementNumber, unlockCost } = this.props;

    incrementNumber(-unlockCost);
    this.setState(() => ({ isUnlocked: true }));
  };

  isUnlocked = () => {
    const { isUnlocked } = this.state;
    return isUnlocked;
  };

  canAutomate = () => {
    const { automateCost, currentNumber } = this.props;
    const { isAutomated } = this.state;
    return !isAutomated && currentNumber > automateCost;
  };

  doAutomate = () => {
    const { automateCost, incrementNumber } = this.props;
    const { isWaiting } = this.state;

    incrementNumber(-automateCost);
    this.setState({ isAutomated: true });

    if (!isWaiting) {
      this.onUse();
    }
  };

  isAutomated = () => {
    const { isAutomated } = this.state;
    return isAutomated;
  };

  onUse = () => {
    const { incrementNumber } = this.props;

    const currentIncome = this.getCurrentIncome();
    incrementNumber(currentIncome);

    this.startWait();
  };

  startWait = () => {
    const { waitTime } = this.props;

    this.setState({ isWaiting: true });

    window.setTimeout(() => {
      const { isAutomated } = this.state;
      this.setState({ isWaiting: false }, () => {
        this.forceUpdate(); // force the animation class to be removed from progressLayer

        if (isAutomated) {
          window.setTimeout(this.onUse, 200);
        }
      });
    }, waitTime * 1000);
  };

  render() {
    const {
      automateCost,
      forceInvisible,
      name,
      waitTime,
      unlockCost
    } = this.props;
    const { currentLevel, isAutomated, isWaiting, isUnlocked } = this.state;
    if (forceInvisible) {
      return <li className="upgrade notVisible">?</li>;
    }

    if (!isUnlocked) {
      return (
        <li className="upgrade notVisible">
          <span>?</span>
          <div className="actions">
            <button disabled={!this.canUnlock()} onClick={this.doUnlock}>
              {`Unlock (-${unlockCost})`}
            </button>
          </div>
        </li>
      );
    }

    const income = helpers.prettyPrintNumber(this.getCurrentIncome());
    const cost = helpers.prettyPrintNumber(this.getCurrentCost());

    return (
      <li className="upgrade">
        <div
          className={`progress-layer${
            isWaiting ? " progress-layer-animated" : ""
          }`}
          style={{ animationDuration: `${waitTime}s` }}
        />
        <span>{name}</span>
        <span className="lvl">{`lvl: ${currentLevel}`}</span>
        <span className="lvl">{`rate: +${income} / ${waitTime}s`}</span>
        <div className="actions">
          {!isAutomated ? (
            <React.Fragment>
              <button disabled={isWaiting} onClick={this.onUse}>
                {`Use (+${income})`}
              </button>
              <button
                disabled={!this.canAutomate()}
                onClick={this.doAutomate}
              >{`Automate (-${automateCost})`}</button>
            </React.Fragment>
          ) : (
            <button
              disabled={!this.canUpgrade()}
              onClick={this.doUpgrade}
            >{`Upgrade (-${cost})`}</button>
          )}
        </div>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AutoClicker.jsx